export const apiConstants = {
  referralPayoutAmount: 'Club/NetworkStats',
};
